<template>
  <svg v-bind="$attrs">
    <slot v-if="$slots.default"></slot>
    <use
      v-else
      :href="href ? href : `/img/icons/icons.svg#${icon}`"
    ></use>
  </svg>
</template>

<script setup lang="ts">
  defineProps<{
    icon?: string;
    href?: string;
  }>();
</script>
